import { getCountries, getCountryCallingCode } from 'react-phone-number-input';

export interface Country {
    code: string;
    name: string;
    phoneCode: string;
}

// Get countries from react-phone-number-input library
const countryCodes = getCountries();
export const countries: Country[] = countryCodes
    .map(code => ({
        code,
        name: new Intl.DisplayNames(['en'], { type: 'region' }).of(code) || code,
        phoneCode: `+${getCountryCallingCode(code)}`,
    }))
    .sort((a, b) => a.name.localeCompare(b.name)); // Sort alphabetically by name

export const getCountryByCode = (code: string): Country | undefined => {
    return countries.find(country => country.code === code);
};

export const getCountryByPhoneCode = (phoneCode: string): Country | undefined => {
    return countries.find(country => country.phoneCode === phoneCode);
};
